/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Immunization } from './Immunization';
import {
    ImmunizationFromJSON,
    ImmunizationFromJSONTyped,
    ImmunizationToJSON,
} from './Immunization';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
} from './Invoice';

/**
 * Paid immunization with associated invoice
 * @export
 * @interface PaidImmunizationDetail
 */
export interface PaidImmunizationDetail {
    /**
     * Patient ID
     * @type {string}
     * @memberof PaidImmunizationDetail
     */
    patient_id?: string;
    /**
     * 
     * @type {Immunization}
     * @memberof PaidImmunizationDetail
     */
    immunization?: Immunization;
    /**
     * 
     * @type {Invoice}
     * @memberof PaidImmunizationDetail
     */
    invoice?: Invoice;
}

/**
 * Check if a given object implements the PaidImmunizationDetail interface.
 */
export function instanceOfPaidImmunizationDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaidImmunizationDetailFromJSON(json: any): PaidImmunizationDetail {
    return PaidImmunizationDetailFromJSONTyped(json, false);
}

export function PaidImmunizationDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaidImmunizationDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'immunization': !exists(json, 'immunization') ? undefined : ImmunizationFromJSON(json['immunization']),
        'invoice': !exists(json, 'invoice') ? undefined : InvoiceFromJSON(json['invoice']),
    };
}

export function PaidImmunizationDetailToJSON(value?: PaidImmunizationDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'immunization': ImmunizationToJSON(value.immunization),
        'invoice': InvoiceToJSON(value.invoice),
    };
}

